// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const SPLIT_PANEL_MIN_HEIGHT = 160;
export const SPLIT_PANEL_MIN_WIDTH = 280;



// WEBPACK FOOTER //
// /Volumes/src/app-layout/split-panel/constants.ts